import Address, { AddressProps } from './Address';

export type { AddressProps };
export default Address;
